import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppData } from '@shared/models/appdata.model';
import { ANumberResponse } from '../modules/subscription/models/available-numbers-response.model';
import { SimCard } from '../models/simcard.model';
import { OrderSimRequest } from '@support/models/order-sim-request.model';

@Injectable({
  providedIn: 'root',
})
export class SimService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  availableNumbers(customerId?: string): Observable<ANumberResponse> {
    const url = `${this.apiUrl}/sim/availableNumbers?customerId=${customerId}&numberSeriesType=Normal&numberCategory=Voice`;
    return this.http.get<ANumberResponse>(url);
  }

  simCard(icc: string): Observable<SimCard> {
    const url = `${this.apiUrl}/sim/simCard?icc=${icc}`;
    return this.http.get<SimCard>(url);
  }

  orderBulkSim(request: OrderSimRequest) {
    const url = `${this.apiUrl}/sim/order-bulk-sim`;
    return this.http.post(url, request);
  }
}
